import { Flex, Spin } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { useBreakpoint, useVisualViewport } from '@/shared/lib/hooks';
import { fullScreenMinHeight } from '@/shared/lib/mobileUi';
import { OfflineBanner } from '@/shared/offline-banner';
import { AntdProvider, PwaUpdatePrompt, StoreProvider } from './providers';
import { useBootstrap } from './bootstrap/useBootstrap';
import { router } from './router';

function Bootstrapped() {
  const ready = useBootstrap();
  const { isMobile } = useBreakpoint();

  if (!ready) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: fullScreenMinHeight(isMobile) }}>
        <Spin size="large" />
      </Flex>
    );
  }

  return (
    <>
      <OfflineBanner />
      <PwaUpdatePrompt />
      <RouterProvider router={router} />
    </>
  );
}

export function App() {
  useVisualViewport();
  return (
    <StoreProvider>
      <AntdProvider>
        <Bootstrapped />
      </AntdProvider>
    </StoreProvider>
  );
}
